const YOUTUBE_REGEXP =
  /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/gm;
const VIMEO_REGEXP =
  /^(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^]*)\/videos\/|video\/|)(\d+)(?:|\/\?)$/gim;

const getYouTubeId = (url: string) => {
  const parts = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return parts[2] !== undefined ? parts[2].split(/[^0-9a-z_]/i)[0] : parts[0];
};

export function validationIframeLink(url?: string) {
  if (!url) {
    return false;
  }

  const matches = url.match(/(<iframe |src="https)/g);
  const isValid = matches && Boolean(matches.length >= 2);

  if (isValid) {
    return true;
  }

  const youtubeMatch = url.match(YOUTUBE_REGEXP);

  if (youtubeMatch) {
    return true;
  }

  const vimeoMatch = url.match(VIMEO_REGEXP);

  return Boolean(vimeoMatch);
}

export const isPowerPointLink = (url: string) => {
  const pptRegex = /\.(ppt|pptx|pps|ppsx)$/i;
  const googleSlidesPattern = /docs\.google\.com\/presentation\/d\//i;
  const urlRegex = /^https?:\/\//i;

  return (urlRegex.test(url) && pptRegex.test(url)) || googleSlidesPattern.test(url);
};

const regexSrcAttr = /src=['"](.*?)['"]/;
const regexAllowAttr = /allow=['"](.*?)['"]/;

export const getIframeTemplate = (value: string) => {
  const srcAttr = regexSrcAttr.exec(value);
  const allowAttr = regexAllowAttr.exec(value);

  if (!srcAttr) {
    const youtubeMatch = value.match(YOUTUBE_REGEXP);

    if (youtubeMatch) {
      const youTubeId = getYouTubeId(value);

      return `<iframe src="https://www.youtube.com/embed/${youTubeId}" allowfullscreen></iframe>`;
    }

    const vimeoMatch = value.match(VIMEO_REGEXP);

    if (vimeoMatch) {
      const match = /vimeo.*\/(\d+)/i.exec(value);

      if (match) {
        return `<iframe src="https://player.vimeo.com/video/${match[1]}" allowfullscreen></iframe>`;
      }
    }

    return "";
  }

  return `<iframe src="${srcAttr ? srcAttr[1] : ""}" ${
    allowAttr ? allowAttr[0] : ""
  } allowfullscreen></iframe>`;
};
